import * as _ from 'underscore';
import * as ko from 'knockout';
import { IObjectNotInValidationParams } from '../../interfaces';
import { Localization } from '../../compile';
import * as Globalize from '@mapp/globalize';
import { FileInput } from '../../models/ui/uiElements';

export interface KnockoutValidationRuleDefinitions {
	isValidName: KnockoutValidationRuleDefinition;
	isValidTitle: KnockoutValidationRuleDefinition;
	isValidUsername: KnockoutValidationRuleDefinition;
	objectNotIn: KnockoutValidationRuleDefinition;
	lessThanDigit: KnockoutValidationRuleDefinition;
	greaterThanDigit: KnockoutValidationRuleDefinition;
	email_v2: KnockoutValidationRuleDefinition;
	atLeastOne: KnockoutValidationRuleDefinition;
	isValidNumber: KnockoutValidationRuleDefinition;
}

export function isValidName(name: string) {
	return name && name.length <= 64 && !name.match(/\W/i);
}

function isValidTitle(title: string) {
	return title && title.length <= 128 && !title.match(/[!"&§$%´`#':;\?\\~|+<>\.]/);
}

function isValidUsername(username: string) {
	return username && username.length <= 128 && !username.match(/[!"&§$%´`#':;\?\\~|+<>]/);
}

(function(ko: KnockoutStatic) {
	ko.validation.rules.isValidNumber = {
		validator: function(number: string, params: any) {
			if (!_.isEmpty(number)) {
				let parsedString = number.replace(params.groupingRegExp(), '');
				let parsedNumber = Globalize.parseNumber(parsedString);
				return !isNaN(parsedNumber);
			}
			return true;
		},
		message: Localization.Validation.number
	};

	ko.validation.rules.greaterThanMaxNumber = {
		validator: function(number: string, params: any) {
			if (!_.isEmpty(number)) {
				let parsedString = number.replace(params.groupingRegExp(), '');
				let parsedNumber = Globalize.parseNumber(parsedString);
				return !isNaN(parsedNumber) && parsedNumber <= Number.MAX_SAFE_INTEGER;
			}
			return true;
		},
		message: Localization.Validation.greaterThanMaxNumber
	};

	ko.validation.rules.lessThanMinNumber = {
		validator: function(number: string, params: any) {
			if (!_.isEmpty(number)) {
				let parsedString = number.replace(params.groupingRegExp(), '');
				let parsedNumber = Globalize.parseNumber(parsedString);
				return !isNaN(parsedNumber) && parsedNumber >= Number.MIN_SAFE_INTEGER;
			}
			return true;
		},
		message: Localization.Validation.lessThanMinNumber
	};

	ko.validation.rules.isValidName = {
		validator: function(name: string, params: any) {
			return isValidName(name);
		},
		message: Localization.Validation.isValidName
	};
	ko.validation.rules.isValidTitle = {
		validator: function(title: string, params: any) {
			return isValidTitle(title);
		},
		message: Localization.Validation.isValidTitle
	};

	ko.validation.rules.isValidUsername = {
		validator: function(username: string, params: any) {
			return isValidUsername(username);
		},
		message: Localization.Validation.isValidUsername
	};

	ko.validation.rules.objectNotIn = <KnockoutValidationRuleDefinition>{
		validator: function(val, params: IObjectNotInValidationParams) {
			var items = [];
			if (!_.isEmpty((items = params.items()))) {
				var doubleEntry = _.find(items, (item: any) => {
					var itemId = ko.utils.unwrapObservable(item[params.idKey]);
					var itemPropertyValue = ko.utils.unwrapObservable(item[params.propertyKey]);
					return itemId != params.idValue && itemPropertyValue == val;
				});
				return _.isEmpty(doubleEntry);
			} else {
				return true;
			}
		}
	};
	ko.validation.rules.lessThanDigit = <KnockoutValidationRuleDefinition>{
		validator: function(val, otherVal) {
			val = parseInt(val);
			otherVal = parseInt(otherVal);
			if (
				_.isNumber(val) &&
				_.isNumber(otherVal) &&
				ko.validation.rules.digit.validator(otherVal, true)
			) {
				return val < otherVal;
			} else {
				return true;
			}
		},
		message: Localization.Validation.lessThanDigit
	};
	ko.validation.rules.greaterThanDigit = <KnockoutValidationRuleDefinition>{
		validator: function(val, otherVal) {
			val = parseInt(val);
			otherVal = parseInt(otherVal);
			if (
				_.isNumber(val) &&
				_.isNumber(otherVal) &&
				ko.validation.rules.digit.validator(otherVal, true)
			) {
				return val > otherVal;
			} else {
				return true;
			}
		},
		message: Localization.Validation.greaterThanDigit
	};
	ko.validation.rules.email_v2 = <KnockoutValidationRuleDefinition>{
		validator: function(val) {
			return (
				!_.isEmpty(val) &&
				val.match(
					/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i
				)
			);
		},
		message: Localization.Validation.email_v2
	};
	ko.validation.rules.atLeastOne = <KnockoutValidationRuleDefinition>{
		validator: function(val, params: any[]) {
			let selected = _.find(params, function(param) {
				let paramVal = ko.isObservable(param) ? (<KnockoutObservable<any>>param)() : param;
				return paramVal != null && paramVal != undefined && (_.isBoolean(paramVal) && paramVal);
			});
			return selected != null && selected != undefined;
		},
		message: Localization.Validation.atLeastOne
	};
	ko.validation.rules.fileSize = <KnockoutValidationRuleDefinition>{
		validator: function(val: string, fileInput: FileInput): boolean {
			return fileInput.fileSize < fileInput.fileSizeLimit;
		},
		message: Localization.Validation.fileSize
	};
	ko.validation.registerExtenders();
})(ko);
